<template>
    <div :class="['field field--input', filled]">
        <div>
            <label
                :for="id"
                class="title bold static-label"
                v-if="staticLabel">
                {{ label }}
            </label>
            <textarea-autosize
                v-if="autosize"
                class="input-component"
                :placeholder="placeholder"
                ref="myTextarea"
                :value="value"
                @input="emitInput"
                :min-height="52"
                :max-height="350"
                rows="1"
            />
            <input
                v-else
                class="input-component"

                :id="id"
                :value="value"
                :type="inputType"
                :placeholder="placeholder"
                @input="$emit('input', $event.target.value)"
                @blur="$emit('blur')"
                @focus="$emit('focus')"
                :required="required"
                :readonly="readonly"
                :class="{'p-0': inputType === 'color'}"
            >
            <label
                v-if="!staticLabel"
                class="dynamic-label"
                :for="id">
                <span>{{ label }}</span>
            </label>
            <i
                :class="['i-eye toggle--password', {'show' : showPassword }]"
                v-if="inputType === 'password'"
                @click.prevent="togglePassword()"></i>
        </div>
        <small
            v-if="errors.length"
            v-html="errors.join('<br/>\n')"
            class="text-danger"></small>
        <small v-else-if="hint">{{ hint }}</small>
    </div>
</template>

<script>
    export default {
        name: 'CoreCheckbox',
        data() {
            return {
                error: false,
                type: null,
                showPassword: false
            }
        },
        props: {
            id: {
                type: String,
                default() { return `text-input-${this._uid}`}
            },
            label: {
                type: String,
                default: ''
            },
            inputType: {
                type: String,
                default: 'text'
            },
            hint: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                defualt: ''
            },
            value : {
                required: false,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            errors: {
                type: Array,
                default: () => []
            },
            staticLabel: {
                type: Boolean,
                default: false
            },
            autosize: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            filled(){
                if ( this.value ) {
                    return 'is-focused'
                } else {
                    return false
                }
            }
        },
        methods: {
            togglePassword() {
                this.showPassword = !this.showPassword
                event.preventDefault()
                const field = document.getElementById(this.id);
                if(field.type === 'password') {
                    field.type = 'text'
                } else {
                    field.type = 'password'
                }
            },
            emitInput(value) {
                this.$emit('input', value)
            }
        }
    }
</script>

<style lang="scss" scoped>
.field--input {
    & > div {
        position: relative;
    }

    .static-label {
        display: block;
        margin-bottom: 0.5rem;
        color: var(--text-dark);
    }

    .input-component {
        display: inline-flex;
        // border: 1px solid var(--border-grey);

        width: 100%;
        padding: 1rem;
        border: none;
        border-radius: 4px;
        box-shadow: inset 0 0 0 1px  var(--border-grey-50);
        font-size: 1rem;

        &:focus {
            border-color: var(--border-grey-dark);
        }

        &.is-complete {
            // @extend %.input-component-complete;
        }

        &.is-error {
            // @extend %.input-component-error;
        }

        &.static-label {
            &::placeholder {
                opacity: 1;
            }
        }

        &[readonly] {
            background-color: var(--grey-25);

            & + .dynamic-label {
                background-color: transparent;
            }
        }
    }

    .input-component + .dynamic-label {
        position: absolute;
        top: 50%;
        left: 0.75rem;
        padding: 0 0.25rem;
        transform: translateY(-50%);
        background-color: #fff;
        color: #b6babe;
        font-size: 0.875rem;

        @include transition(0.3s all);
    }

    .input-component:focus + .dynamic-label,
    &.is-focused .input-component + .dynamic-label {
        top: 0;
        color: var(--text-dark);
        font-size: 12px;
        font-weight: bold;

        &::placeholder {
            opacity: 1;
        }
    }

    .input-component::placeholder {
        // opacity: 0;
    }

    .input-component:focus,
    &.is-focused input {
        &::placeholder {
            opacity: 1;
        }
    }

    .toggle--password {
        position: absolute;
        top: 50%;
        right: 1.5rem;
        transform: translateY(-50%);
        color: var(--secondary);

        &.show {
            opacity: 0.25;
        }
    }

    small {
        display: block;
        margin-top: 0.5rem;

        &.text-danger {
            color: var(--system-red);
        }
    }
}
</style>
